/** @format */

import React from "react";
import * as Yup from "yup";
import { useForgotPasswordMutation } from "store/services/authAPI";
import { useFormik } from "formik";
import Swal from "sweetalert2";
import { replaceUnderscoresWithSpaces } from "utils/strings";
import loginbg from "../../images/Login.png";
import { ReactComponent as EnvIcon } from "images/svg/enveloope.svg";
import AuthHeader from "./components/auth-header";

function NewForgotPassword() {
  const [forgotPassword, { isLoading: requesting }] =
    useForgotPasswordMutation();

  const handleSubmit = async (values) => {
    await forgotPassword({
      redirect_url: `${process.env.REACT_APP_FRONTEND_URL}reset-password`,
      email: values.email,
    })
      .unwrap()
      .then((data) => {
        Swal.fire({
          title: "Notice",
          icon: "success",
          text: data?.detail,
          showCloseButton: true,
          customClass: {
            icon: "no-border",
          },
          confirmButtonText: "Ok",
        });
      })
      .catch((error) => {
        const errorText = error?.data?.detail;
        const btnText = "Try Again";

        Swal.fire({
          title: error?.data?.code
            ? replaceUnderscoresWithSpaces(error?.data?.code)
            : "Error Occured",
          iconHtml: ` <i class="fa fa-exclamation-triangle text-danger" aria-hidden="true"></i>`,
          text: errorText || "Error Occured",
          showCloseButton: true,
          customClass: {
            icon: "no-border",
          },
          cancelButtonText: btnText,
          showConfirmButton: false,
          showCancelButton: true,
        });
      });
  };

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: UserSchema,
    onSubmit: handleSubmit,
    enableReinitialize: true,
  });

  return (
    <>
      <div
        className="login-main-page auth-page"
        style={{
          background: "url(" + loginbg + ")",
          backgroundSize: "contain",
        }}
      >
        <AuthHeader />

        <div className="login-wrapper w-100 mt-4">
          <div className="container h-100">
            <div className="row h-100 align-items-center justify-content-center">
              <div className="col-xl-6 mt-3">
                <div className="card auth-card">
                  <div className="card-body p-0">
                    <div className="row m-0">
                      <div className="col-xl-12 col-md-12">
                        <div className="sign-in-your">
                          <h4 className="fs-20 font-w800 text-black">
                            Forgot Password
                          </h4>

                          <p className="mb-2 welcome">
                            Don’t worry, we’ve got you covered{" "}
                            <span>
                              <svg
                                width="22"
                                height="16"
                                viewBox="0 0 22 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M20 0.5H2C1.60218 0.5 1.22064 0.658035 0.93934 0.93934C0.658035 1.22064 0.5 1.60218 0.5 2V14C0.5 14.3978 0.658035 14.7794 0.93934 15.0607C1.22064 15.342 1.60218 15.5 2 15.5H20C20.3978 15.5 20.7794 15.342 21.0607 15.0607C21.342 14.7794 21.5 14.3978 21.5 14V2C21.5 1.60218 21.342 1.22064 21.0607 0.93934C20.7794 0.658035 20.3978 0.5 20 0.5ZM18.1794 9.37906C18.2373 9.45909 18.2789 9.54974 18.3018 9.64584C18.3247 9.74194 18.3284 9.8416 18.3128 9.93915C18.2972 10.0367 18.2625 10.1302 18.2107 10.2143C18.1589 10.2985 18.0911 10.3716 18.0111 10.4295C17.9311 10.4875 17.8404 10.5291 17.7443 10.5519C17.6482 10.5748 17.5486 10.5786 17.451 10.563C17.3535 10.5473 17.26 10.5126 17.1758 10.4609C17.0917 10.4091 17.0186 10.3413 16.9606 10.2612L16.25 9.27594L15.5347 10.2612C15.4177 10.4229 15.2413 10.5314 15.0443 10.563C14.8473 10.5945 14.6458 10.5465 14.4842 10.4295C14.3226 10.3125 14.2141 10.1361 14.1825 9.93915C14.151 9.74215 14.199 9.54068 14.3159 9.37906L15.0322 8.39469L13.8734 8.01969C13.7798 7.98891 13.6932 7.93999 13.6184 7.87572C13.5437 7.81146 13.4824 7.7331 13.4379 7.64514C13.3482 7.46747 13.3327 7.26144 13.3948 7.07234C13.4256 6.97872 13.4745 6.89207 13.5388 6.81734C13.6031 6.74262 13.6814 6.68129 13.7694 6.63685C13.9471 6.54709 14.1531 6.53159 14.3422 6.59375L15.5 6.96875V5.75C15.5 5.55109 15.579 5.36032 15.7197 5.21967C15.8603 5.07902 16.0511 5 16.25 5C16.4489 5 16.6397 5.07902 16.7803 5.21967C16.921 5.36032 17 5.55109 17 5.75V6.96875L18.1578 6.59375C18.2514 6.56297 18.3502 6.55094 18.4485 6.55833C18.5468 6.56572 18.6426 6.5924 18.7306 6.63685C18.8186 6.68129 18.8969 6.74262 18.9612 6.81734C19.0255 6.89207 19.0744 6.97872 19.1052 7.07234C19.1359 7.16597 19.148 7.26475 19.1406 7.36303C19.1332 7.46131 19.1065 7.55717 19.0621 7.64514C19.0176 7.7331 18.9563 7.81146 18.8816 7.87572C18.8068 7.93999 18.7202 7.98891 18.6266 8.01969L17.4678 8.39469L18.1794 9.37906ZM11.4294 9.37906C11.4873 9.45909 11.5289 9.54974 11.5518 9.64584C11.5747 9.74194 11.5784 9.8416 11.5628 9.93915C11.5472 10.0367 11.5125 10.1302 11.4607 10.2143C11.4089 10.2985 11.3411 10.3716 11.2611 10.4295C11.1811 10.4875 11.0904 10.5291 10.9943 10.5519C10.8982 10.5748 10.7986 10.5786 10.701 10.563C10.6035 10.5473 10.5099 10.5126 10.4258 10.4609C10.3417 10.4091 10.2686 10.3413 10.2106 10.2612L9.5 9.27594L8.78469 10.2612C8.6677 10.4229 8.49131 10.5314 8.29431 10.563C8.0973 10.5945 7.89583 10.5465 7.73422 10.4295C7.5726 10.3125 7.46408 10.1361 7.43252 9.93915C7.40096 9.74215 7.44895 9.54068 7.56594 9.37906L8.28219 8.39469L7.12344 8.01969C7.02981 7.98891 6.94316 7.93999 6.86844 7.87572C6.79371 7.81146 6.73238 7.7331 6.68794 7.64514C6.59819 7.46747 6.58268 7.26144 6.64484 7.07234C6.67562 6.97872 6.72454 6.89207 6.78881 6.81734C6.85307 6.74262 6.93143 6.68129 7.0194 6.63685C7.19706 6.54709 7.4031 6.53159 7.59219 6.59375L8.75 6.96875V5.75C8.75 5.55109 8.82902 5.36032 8.96967 5.21967C9.11032 5.07902 9.30109 5 9.5 5C9.69891 5 9.88968 5.07902 10.0303 5.21967C10.171 5.36032 10.25 5.55109 10.25 5.75V6.96875L11.4078 6.59375C11.5014 6.56297 11.6002 6.55094 11.6985 6.55833C11.7968 6.56572 11.8926 6.5924 11.9806 6.63685C12.0686 6.68129 12.1469 6.74262 12.2112 6.81734C12.2755 6.89207 12.3244 6.97872 12.3552 7.07234C12.3859 7.16597 12.398 7.26475 12.3906 7.36303C12.3832 7.46131 12.3565 7.55717 12.3121 7.64514C12.2676 7.7331 12.2063 7.81146 12.1316 7.87572C12.0568 7.93999 11.9702 7.98891 11.8766 8.01969L10.7178 8.39469L11.4294 9.37906ZM5 4.25V11.75C5 11.9489 4.92098 12.1397 4.78033 12.2803C4.63968 12.421 4.44891 12.5 4.25 12.5C4.05109 12.5 3.86032 12.421 3.71967 12.2803C3.57902 12.1397 3.5 11.9489 3.5 11.75V4.25C3.5 4.05109 3.57902 3.86032 3.71967 3.71967C3.86032 3.57902 4.05109 3.5 4.25 3.5C4.44891 3.5 4.63968 3.57902 4.78033 3.71967C4.92098 3.86032 5 4.05109 5 4.25Z"
                                  fill="#010D14"
                                />
                              </svg>
                            </span>
                          </p>

                          <form
                            className="form mt-4"
                            onSubmit={formik.handleSubmit}
                          >
                            <div className="mb-3">
                              <label className="mb-1">
                                <strong>Email Address</strong>
                              </label>

                              <div className="password__container">
                                <EnvIcon />
                                <input
                                  type="email"
                                  className="form-control"
                                  id="email"
                                  name="email"
                                  placeholder="e.g. example@domainname.com"
                                  {...formik.getFieldProps("email")}
                                />
                              </div>

                              {formik.touched.email && formik.errors.email ? (
                                <div className="text-danger mt-2 fs-12">
                                  {formik.errors.email}
                                </div>
                              ) : null}
                            </div>

                            <div className="text-center">
                              <button
                                type="submit"
                                className="btn btn-primary btn-block"
                              >
                                {requesting ? (
                                  <span
                                    role="status"
                                    aria-hidden="true"
                                    className="spinner-border spinner-border-sm ms-2"
                                  ></span>
                                ) : (
                                  "Request Link"
                                )}
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default NewForgotPassword;

const UserSchema = Yup.object().shape({
  email: Yup.string().email().required("Email is required"),
});
